import Vue from 'vue'
import SvgIcon from './svgIcon'
import path from 'path'
// svg组件
const dir = path.resolve(__dirname, 'src/assets/icons')
// register globally
Vue.component('svg-icon', SvgIcon)
const requireAll = (requireContext) => requireContext.keys().map(requireContext)
const req = require.context('../../assets/icons/', true, /\.svg$/)
requireAll(req)